import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Button,
  Col,
  Input,
} from "reactstrap";
import "react-nice-dates/build/style.css";
import { ChevronRight } from "@styled-icons/bootstrap/ChevronRight";
import { DateRangePicker } from "react-nice-dates";
import { sv } from "date-fns/locale";
import { FormattedMessage } from "react-intl";
import { format, isValid } from "date-fns";

export default function ChangeAPLPeriodDateModal({
  periodName,
  isOpen,
  toggle,
  newStartDate,
  newEndDate,
  setNewStartDate,
  setNewEndDate,
  handleChangeStartOrEndDates,
}) {
  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{periodName}</ModalHeader>
      <ModalBody>
        <Col lg={12}>
          <DateRangePicker
            startDate={newStartDate}
            endDate={newEndDate}
            onStartDateChange={setNewStartDate}
            onEndDateChange={setNewEndDate}
            minimumLength={1}
            format="yyyy-MM-dd"
            locale={sv}
          >
            {({ startDateInputProps, endDateInputProps, focused }) => (
              <>
                <Col
                  lg={4}
                  style={{ display: "inline-block", padding: "0 6px" }}
                >
                  <Col
                    style={{
                      padding: "6px",
                      textAlign: "center",
                    }}
                  >
                    <Input
                      {...startDateInputProps}
                      value={
                        newStartDate && isValid(newStartDate)
                          ? format(newStartDate, "yyyy-MM-dd")
                          : ""
                      }
                      style={{ textAlign: "center" }}
                      className={"input" + (focused ? " -focused" : "")}
                    />
                  </Col>
                </Col>
                <ChevronRight size="1rem" style={{ margin: "1rem" }} />
                <Col lg={4} style={{ display: "inline-block", padding: "0" }}>
                  <Col
                    style={{
                      padding: "6px",
                      textAlign: "center",
                    }}
                  >
                    <Input
                      {...endDateInputProps}
                      value={
                        newEndDate && isValid(newEndDate)
                          ? format(newEndDate, "yyyy-MM-dd")
                          : ""
                      }
                      style={{ textAlign: "center" }}
                      className={"input" + (focused ? " -focused" : "")}
                    />
                  </Col>
                </Col>
              </>
            )}
          </DateRangePicker>
        </Col>
      </ModalBody>
      <ModalFooter>
        <Button outline color="secondary" onClick={toggle}>
          <FormattedMessage id="Cancel" />
        </Button>
        <Button
          onClick={() => handleChangeStartOrEndDates(newStartDate, newEndDate)}
          color="primary"
          outline
        >
          <FormattedMessage id="Continue" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
